import { searchProduct } from "../api/dataFactory";
import { getImage } from "../api/dataFactory";
import router from "../plugins/router";

const PRODUCT_PER_PAGE = 15;

const productBrowseMixins = {
    props: {
        category: {
            type: String,
            default: "health"
        },
        page: {
            type: String,
            default: "1"
        },
        subCategory: String,
        keyword: String
    },
    metaInfo: {
        title: "Health Care | 1byone",
        meta: [{
                vmid: "description",
                name: "description",
                content: "Take care of your health with best products-1byone massagers,blood pressure monitor,6in1 thermometer,muscle stimulator,fingertip pulse oximeter and more."
            },
            {
                vmid: "keywords",
                name: "keywords",
                content: "1byone,1byonehealth, massagers,blood pressure monitor,bluetooth blood pressure monitor,6in1 thermometer,muscle stimulator,fingertip pulse oximeter,mechanical bidet,electrode pads"
            }
        ]
    },
    data() {
        return {
            getImage,
            products: [],
            productCategory: [{
                    name: "HEALTH LIFE",
                    term: "health"
                },
                {
                    name: "SMART LIFE",
                    term: "smart"
                }
            ],
            productSubcategories: {
                health: [{
                        name: "Weight Scale",
                        term: "scale"
                    },
                    {
                        name: "Water Bottle",
                        term: "bottle"
                    },
                    {
                        name: "Oximeter",
                        term: "oximeter"
                    },
                    // {
                    //   name: "Nebulizer (1)",
                    //   term: "nebulizer"
                    // },
                    {
                        name: "Blood Pressure Monitor",
                        term: "bloodPressureMonitor"
                    },
                    {
                        name: "ECG Monitor ",
                        term: "ecgMonitor"
                    },
                    {
                        name: " TENS ",
                        term: "tens"
                    },
                    {
                        name: "White Noise Machine",
                        term: "whitenoiseMachine"
                    },
                    {
                        name: "Resistance Band",
                        term: "resistanceBand"
                    }
                ],
                smart: []
            },
            rating: 5,
            selectedCategory: this.category,
            selectedSubcategory: this.subCategory,
            loading: true
        };
    },
    created() {
        this.initData();
    },

    methods: {
        async initData() {
            this.resetData();
            this.products = await searchProduct(this.searchParams);
            // this.products.sort(this.dynamicSort("subCategory"));
            this.loading = false;
        },

        dynamicSort(property) {
            var sortOrder = 1;

            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }

            return function(a, b) {
                if (sortOrder == -1) {
                    return b[property].localeCompare(a[property]);
                } else {
                    return a[property].localeCompare(b[property]);
                }
            };
        },

        getCategoryFullName(category) {
            return this.productCategory.find(c => c.term == category).name;
        },

        isActiveSubcategory(subCat) {
            return subCat.term == this.selectedSubcategory;
        },

        updateSubcategory(subcategory) {
            if (this.selectedSubcategory != subcategory.term) {
                this.selectedSubcategory = subcategory.term;
                router.push({
                    path: "/product/browse",
                    // path: "/product",
                    query: { c: this.selectedCategory, sc: this.selectedSubcategory }
                });
            }
        },

        updateCategory(category) {
            if (this.selectedCategory != category.term) {

                this.selectedCategory = category.term;
                this.selectedSubcategory = "";
                router.push({
                    path: "/product/browse",
                    // path: "/product",
                    query: { c: this.selectedCategory }
                });
            }
        },

        hasProductSubcategory() {
            return this.productSubcategory.length != 0;
        },

        getProductImage(id, productImage) {
            let path = "/product/" + id + "/" + productImage;
            return this.getImage(path);
        },

        getProductDetailPageUrl(product) {
            // return "/product/dp/" + product.id;
            // return "/product/" + product.id;
            // return "/p/" + product.id;
            return "/" + product.id;
        },

        resetData() {
            this.loading = true;
            this.products = [];
        },

        getSearchResultErrorHint() {
            let hint = "";
            if (this.keyword) {
                hint = this.keyword;
            } else if (this.selectedSubcategory) {
                hint = this.selectedSubcategory;
            } else if (this.selectedCategory) {
                hint = this.selectedCategory;
            }
            return hint;
        }
    },
    computed: {
        hasSearchResult() {
            return (!this.loading && this.products != undefined && this.products.length > 0);
        },

        hasNoSearchResult() {
            return (!this.loading &&
                (this.products == undefined || this.products.length == 0)
            );
        },

        productSubcategory() {
            return this.productSubcategories[this.selectedCategory];
        },

        unselectedCategory() {
            return this.productCategory.filter(c => c.term != this.selectedCategory);
        },

        selectedCategoryDislayLabel() {
            return this.productCategory.find(
                category => category.term == this.selectedCategory
            ).name;
        },

        searchParams() {
            return {
                category: this.category,
                subCategory: this.subCategory,
                keyword: this.keyword,
                size: PRODUCT_PER_PAGE,
                from: PRODUCT_PER_PAGE * this.page - PRODUCT_PER_PAGE
            };
        },

        searchResultHintText() {
            return `Search Result For '${this.getSearchResultErrorHint()}'`;
        },

        searchResultFullHintText() {
            return `We are sorry, no result found for your search term '${this.getSearchResultErrorHint()}'`;
        }
    },

    watch: {
        searchParams: {
            handler: "initData",
            deep: true
        }
    }
};

export default productBrowseMixins;